export const testId = {
    allUsersTableSearch: "all-users-table-search",
    inviteUsers: "invite-users",
    userCard: "user-card",
    userProfileForm: "user-profile-form"
} as const
